import React, { useState, useEffect } from "react";
import axios from "axios";
import Ngo from "../ngo/Ngo";
import { useNavigate } from "react-router-dom";
import AdminDashboard from "../admin/AdminDashboard";
import ShowRewards from "../modals/ShowReward";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Dashboard = () => {
  const [userToken, setUserToken] = useState(localStorage.getItem("userToken"));
  const firstLogin = localStorage.getItem("firstLogin");
  const [profile, setProfile] = useState("");
  const [showPopup, setShowPopup] = useState("false");
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState("false");

  useEffect(() => {
    if (!userToken) navigate("/");
  }, [userToken]);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_LOCAL_API}/user`,
          {
            headers: {
              Authorization: `Bearer ${userToken}`,
            },
          }
        );
        setProfile(response?.data?.user?.profileType);
      } catch (err) {
        console.error(err);
      }
    };

    if (userToken) {
      fetchProfile();
    }
  }, [userToken]);

  return (
    <>
      {(() => {
        switch (profile) {
          case "admin":
            return <AdminDashboard />;
          case "view_access":
            return <AdminDashboard />;
          case "impactOrg":
            return <Ngo />;
          case "ngo":
            return <Ngo />;
          case "individual":
            return <Ngo />;
          case "business":
            return <Ngo />;

          default:
            navigate("/");
            return null;
        }
      })()}
      {firstLogin === "true" && (
        <ShowRewards
          id={1}
          setIsModalOpen={setIsModalOpen}
          isModalOpen={isModalOpen}
        />
      )}
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={true}
        closeOnClick
        pauseOnFocusLoss
        pauseOnHover
        theme="dark"
      />
    </>
  );
};

export default Dashboard;
